import { createSlice } from '@reduxjs/toolkit';
import { TaskState } from './taskTypes';
import { 
  createTask, 
  fetchTasks, 
  fetchTaskById, 
  updateTask, 
  deleteTask, 
  fetchTaskByProjectId,
  fetchTasksByEmployeeId
} from './taskActions';

const initialState: TaskState = {
  tasks: [],
  TaskByProject:[],
  tasksByEmployee: [],
  selectedTask: undefined,
  loading: false,
  error: undefined,
};

const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Task
      .addCase(createTask.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createTask.fulfilled, (state, action) => {
        state.loading = false;
        state.tasks.push(action.payload);
      })
      .addCase(createTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All Tasks
      .addCase(fetchTasks.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchTasks.fulfilled, (state, action) => {
        state.loading = false;
        state.tasks = action.payload.data;
      })
      .addCase(fetchTasks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Task by ID
      .addCase(fetchTaskById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchTaskById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedTask = action.payload.data;
      })
      .addCase(fetchTaskById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Fetch Task by project id
      .addCase(fetchTaskByProjectId.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchTaskByProjectId.fulfilled, (state, action) => {
        state.loading = false;
        state.TaskByProject = action.payload.data;
      })
      .addCase(fetchTaskByProjectId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Tasks by Employee ID
      .addCase(fetchTasksByEmployeeId.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchTasksByEmployeeId.fulfilled, (state, action) => {
        state.loading = false;
        state.tasksByEmployee = action.payload.data;  // Store tasks fetched by employee ID
      })
      .addCase(fetchTasksByEmployeeId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Task
      .addCase(updateTask.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateTask.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.tasks.findIndex(task => task.id === action.payload.data.TaskID);
        if (index !== -1) {
          state.tasks[index] = action.payload.data;
        }
      })
      .addCase(updateTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete Task
      .addCase(deleteTask.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteTask.fulfilled, (state, action) => {
        state.loading = false;
        state.tasks = state.tasks.filter(task => task.id !== action.payload.id);
      })
      .addCase(deleteTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default taskSlice.reducer;
